module.exports = __webpack_public_path__ + "assets/img/sample.1e4da3b2.png";